export const HeadLinks =[
    {
        id: 1,
        title: "Home"
    }, 
    { 
        id :2,
        title: "Course",
    },
    {
        id : 3,
        title: "Contact Us"
    },
    {
        id: 4, title : "About Us" 
    }
]

export const Quality = [
    {
        id: 1,
        title: "Skilled experience  coaches"
    }, 
    { 
        id :2,
        title: "Time to learn",
    },
    {
        id : 3,
        title: "Dont waste time get alife"
    },
   
]